import { useCallback } from "react";

import { useQuery } from "hooks";

import { createResolverFactory } from "../WorkflowContainer/components/FormFieldBuilder/hooks";

export function useGetCurrentUser() {
  const queryFactory = useCallback(() => {
    const query = `
        query getCurrentUser {
          me {
            id
            insightsEnabled
            email
            preferences
          }
        }`;

    const resolver = ({ data: { me } }) => {
      return {
        ...me,
        preferences: me?.preferences ? JSON.parse(me?.preferences) : null,
      };
    };

    return { query: query, resolver: createResolverFactory(resolver) };
  }, []);

  const { loading, data, reloadData } = useQuery(queryFactory);
  return {
    loadingUser: loading,
    reloadUser: reloadData,
    user: !loading && !Array.isArray(data) ? data : {},
  };
}

export default useGetCurrentUser;
